import React, { ReactElement, useState } from 'react';
import {
  GetScheduleDetailsDocument,
  useCreateScheduleShiftMutation,
} from 'apollo/generated/client-operations';
import { FormOnSubmit, ModalForm } from 'components/form';
import {
  Schedule,
  JobsiteScheduleShiftFormFields,
} from 'containers/jobsite/tabs/jobsiteSchedules/data/types';
import { AlertService } from 'components/alertService';
import { useIsMounted } from 'utils';
import { getGraphQLError } from 'utils/error';
import {
  getAddInput,
  getDefaultValues,
  getFormInputs,
} from './AddShiftModal.forms';

export function AddShiftModal(props: {
  isOpen: boolean;
  closeModal: () => void;
  selectedSchedule: Schedule;
}): ReactElement {
  const { isOpen, closeModal, selectedSchedule } = props;

  const isMounted = useIsMounted();
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const [createScheduleShift] = useCreateScheduleShiftMutation({
    refetchQueries: [GetScheduleDetailsDocument],
  });

  const onSubmit: FormOnSubmit<JobsiteScheduleShiftFormFields> = async (
    data,
    event,
    dirtyFields,
  ): Promise<void> => {
    if (isSaving) return;
    setIsSaving(true);

    try {
      const input = getAddInput(selectedSchedule.id, data, dirtyFields);
      await createScheduleShift({ variables: { input } });
      closeModal();
      AlertService.alert('success', 'Success', 'Shift successfully added');
    } catch (error) {
      event.preventDefault();
      AlertService.alert(
        'danger',
        'Something went wrong!',
        getGraphQLError(error),
      );
    } finally {
      if (isMounted()) {
        setIsSaving(false);
      }
    }
  };

  const inputs = React.useMemo(() => getFormInputs(), []);
  const defaultValues = React.useMemo(() => getDefaultValues(), []);

  return (
    <ModalForm
      actionText="Save"
      defaultValues={defaultValues}
      inputs={inputs}
      inputsContainerClassName="odin-grid odin-grid-cols-12 odin-gap-4"
      onSubmit={onSubmit}
      open={isOpen}
      setOpen={closeModal}
      title="Edit shift settings"
    />
  );
}
